import { $ } from 'jquery';

function Socket() {}

var socketInstance;
var heartCheck;

var createSocket = function () {
  try {
    var ws = new WebSocket(Socket.config.wsUrl);

    ws.onmessage = function (event) {
      Socket.config.onmessage(event);
      heartCheck.reset();
    };

    ws.onclose = function () {
      Socket.config.onclose();
      reconnect();
    };

    ws.onerror = function () {
      Socket.config.onerror();
      reconnect();
    };

    ws.onopen = function () {
      Socket.config.onopen();
      heartCheck.start();
    };

    return ws;
  } catch (error) {
    reconnect();
  }
};

var reconnect = function () {
  if (Socket.config.lockReconnect) {
    return;
  }

  Socket.config.lockReconnect = true;

  if (Socket.config.ShInt == 1) {
    return false;
  }

  setTimeout(function () {
    Socket.config.isqidong = false;
    console.warn('服务器重新连接中....');
    socket.init(Socket.config);
    Socket.config.lockReconnect = false;
  }, 2000);
};

heartCheck = {
  timeout: 0,
  timeoutObj: null,
  serverTimeoutObj: null,
  reset: function () {
    Socket.config.isqidong = true;
    console.warn('心跳');
    clearTimeout(this.timeoutObj);
    clearTimeout(this.serverTimeoutObj);
    heartCheck.start();
  },
  start: function () {
    var that = this;

    this.timeout = Socket.config.timeout;
    this.timeoutObj = setTimeout(function () {
      Socket.config.isqidong = true;

      if (socketInstance && socketInstance.readyState == 1) {
        socketInstance.send(Socket.config.HeartBeat);
      }

      that.serverTimeoutObj = setTimeout(function () {
        Socket.config.isqidong = false;
        if (socketInstance) {
          socketInstance.close();
        }
      }, that.timeout);
    }, this.timeout);
  },
};

Socket.prototype.heartCheck = {
  start: function () {
    heartCheck.start();
  },
  reset: function () {
    heartCheck.reset();
  },
};

Socket.prototype.config = {
  wsUrl: '',
  ShInt: '0',
  lockReconnect: false,
  HeartBeat: '{"type":"HeartBeat"}',
  timeout: 60000,
  onopen: function () {
    console.warn('服务器已连接');
  },
  onmessage: function () {
    console.warn('收到消息....');
  },
  onerror: function () {
    console.warn('服务错误');
  },
  onclose: function () {
    console.warn('服务已关闭');
  },
};

Socket.prototype.init = function (options) {
  var that = this;
  Socket.config = $.extend({}, that.config, Socket.config, options);
  socketInstance = createSocket();
  return socketInstance;
};

Socket.prototype.close = function () {
  clearTimeout(heartCheck.timeoutObj);
  clearTimeout(heartCheck.serverTimeoutObj);
  Socket.config.ShInt = 1;

  if (socketInstance) {
    socketInstance.close();
  }
};

Socket.prototype.send = function (payload) {
  if (socketInstance) {
    socketInstance.send(payload);
  }
};

var socket = new Socket();

if (typeof window !== 'undefined' && window.layui) {
  window.layui.socket = socket;
  window.layui.websocket = socket;
}

export { socket as websocket, socket };
